import { Component } from '@angular/core';
import { AbstractInputComponent } from '@shared/form-fields/abstract-value-accessor/abstract-value';
import { makeProvider } from '@shared/form-fields/make-provider';
import type { Rule } from '@shared/modules/fixed-rates/fixed-rate';

@Component({
    selector: 'app-contract-rules-list',
    templateUrl: './contract-rules-list.component.html',
    styleUrls: ['./contract-rules-list.component.scss'],
    providers: [makeProvider(ContractRulesListComponent)],
})
export class ContractRulesListComponent extends AbstractInputComponent<Rule[]> {
    addRule() {
        if (!Array.isArray(this.value)) {
            this.value = [];
        }

        this.value.push({
            name: null,
            actions: [],
            conditions: [],
        });

        this.dispatchChange();
    }

    removeRule(rule: Rule) {
        const index = this.value?.indexOf(rule);

        if (index > -1) {
            this.value.splice(index, 1);
        }

        this.dispatchChange();
    }

    _trackRuleFn(index: number, rule: Rule) {
        return rule.name;
    }
}
